function getTransitionEndEventName() {
	var transitions = {
		transition: "transitionend",
		OTransition: "oTransitionEnd",
		MozTransition: "transitionend",
		WebkitTransition: "webkitTransitionEnd",
	};
	let bodyStyle = document.body.style;
	for (let transition in transitions) {
		if (bodyStyle[transition] != undefined) {
			return transitions[transition];
		}
	}
}
let transitionEndEventName = getTransitionEndEventName();



const modal = () => {
	// Quick view ajax function modal content

	const modalButton = document.querySelectorAll("[data-modal='true']");
	let modalAlreadyOpen = false;

	if (modalButton) {
		var modal = document.createElement("div");
		modal.className = "modal";

		// create modal container
		modal.innerHTML = `
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <button type="button" class="modal-close" aria-label="Close">
                        <svg class="icon">
                            <use href="#icon-close"></use>
                        </svg>
                    </button>
                    <div class="modal-body">
					<span class="modal-loader loader"></span>
                    </div>
                </div>
            </div>
        </div>
    `;

		// Append the modal container to the body
		document.body.appendChild(modal);

		modalButton.forEach((item) => {
			item.addEventListener("click", (event) => {
				event.preventDefault();
				const postToDisplay = item.querySelector("a").href;
				const modalBody = modal.querySelector(".modal-body");

				// Url de l'ajax wordpress
				const ajaxUrl = modal_ajax.ajax_url;

				// Données à envoyer avec la requête
				const requestData = {
					posturl: postToDisplay,
				};

				// Options de la requête fetch
				const fetchOptions = {
					method: "POST",

					headers: {
						"Content-Type": "application/x-www-form-urlencoded",
					},
					body: new URLSearchParams({
						credentials: "same-origin",
						action: "ajax_modal_content", // nom de l'action WordPress
						data: JSON.stringify(requestData),
						security: modal_ajax.nonce,
					}),
				};

				modal.addEventListener("click", closeModalOutside);

				// si la modal ne vient pas d'être affiché alors
				if (modalAlreadyOpen !== postToDisplay) {
					//add loader first
					console.log("load modal");

					modalBody.innerHTML =
						'<span class="modal-loader loader"></span>';

					// Effectuer la requête fetch
					fetch(ajaxUrl, fetchOptions)
						.then((response) => response.json())
						.then((data) => {
							// Traiter les données renvoyées par le serveur
							if (data.success == false) {
								modal.querySelector(".modal-body").innerHTML =
									"Aucun contenu trouvé";
							} else {
								modal.querySelector(".modal-body").innerHTML =
									data;
								// console.log("load content");
							}
						})
						.catch((error) => {
							// Gérer les erreurs
							console.error(
								"Erreur lors de la requête AJAX:",
								error
							);
						});
				}

				modalAlreadyOpen = postToDisplay;
				document.querySelector("body").classList.add("modal-open");
				modal.classList.add("open");

			
			});
		});
	}

	const closeBtn = document.querySelector(".modal-close");
	if (closeBtn) {
		closeBtn.addEventListener("click", (event) => {
				closeModal();
		});
	}


	 function closeModal() {
			// const modalParent = closeBtn.closest(".modal");
			modal.classList.remove("open");
			document.querySelector("body").classList.remove("modal-open");
			
			// Remove the event listener when the modal is closed
			modal.removeEventListener("click", closeModalOutside);
		}


	function closeModalOutside(event) {
		if (modal.querySelector('.modal-wrapper').contains(event.target) === false) {
			closeModal();
		}
	}


};

export { modal };
